import React, { useEffect, useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
// import DatePickerWithFloatingLabel from 'components/inputs/DatePickerWithFloatingLabel';
// import { AiOutlineDownload } from 'react-icons/ai';
// import { TiArrowUnsorted } from 'react-icons/ti';
import * as _ from 'lodash';
import { DOWNLOAD_USER_CHARGING_HISTORY, USER_CHARGING_HISTORY } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
import moment from 'moment-timezone';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { millisecondsToHourMinute, roundOfDigit, startsWith } from 'components/common/utils';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { BsDownload } from 'react-icons/bs';
// import DropDown from 'components/inputs/DropDown';
// import { AiFillCaretDown } from 'react-icons/ai';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { BiSort } from 'react-icons/bi';
import { IoSearchOutline } from 'react-icons/io5';
import fileDownload from 'js-file-download';

const UserChargingHistory = () => {
  const dispatch = useDispatch();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [searchText, setSearchText] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  // const [fieldValue, setFieldValue] = useState('All');
  const [allUserChargingHistoryData, setAllUserChargingHistoryData] = useState([]);
  const [startDate, setStartDate] = useState(moment(new Date()).tz('Asia/Dubai').startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).tz('Asia/Dubai').endOf('day'));
  const userChargingHistoryList = useSelector((state) => state.userChargingHistory.userChargingHistories);

  const userChargingHistory = useCallback(
    (value) => {
      const data = {
        ...value,
        from: moment(startDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
        status: 'completed',
      };
      dispatch({ type: USER_CHARGING_HISTORY, payload: data });
    },
    [startDate, endDate]
  );

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else {
      const filterDateData = {
        from: moment(startDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
      };
      userChargingHistory(filterDateData);
    }
  }, [startDate, endDate, sortByItem]);

  // const filterData = [
  //   { label: 'Newest', value: 'Newest' },
  //   { label: 'Oldest', value: 'Oldest' },
  //   { label: 'All', value: 'All' },
  // ];

  // useEffect(() => {
  //   const newestData = {
  //     sortBy: '1',
  //   };
  //   fieldValue === 'Newest' && userChargingHistory(newestData);
  //   const oldestData = {
  //     sortBy: '-1',
  //   };
  //   fieldValue === 'Oldest' && userChargingHistory(oldestData);
  //   fieldValue === 'All' && userChargingHistory();
  // }, [fieldValue]);

  useEffect(() => {
    setAllUserChargingHistoryData(
      _.filter(
        userChargingHistoryList,
        (item) =>
          startsWith(_.get(item, 'customer_user_booked.name'), searchText) ||
          startsWith(_.get(item, 'charger.charging_station.name'), searchText) ||
          startsWith(_.get(item, 'transaction_id'), searchText) ||
          startsWith(_.get(item, 'charger.per_unit_rates'), searchText) ||
          startsWith(_.get(item, 'charger.charger_id'), searchText) ||
          startsWith(roundOfDigit((_.get(item, 'meterstop') - _.get(item, 'meterstart')) / 1000, 3).toString(), searchText) ||
          startsWith(roundOfDigit(_.get(item, 'invoice.amount', '-'), 2).toString(), searchText) ||
          startsWith(millisecondsToHourMinute(_.get(item, 'time_taken')).toString(), searchText) ||
          startsWith(moment(_.get(item, 'schedule_datetime')).tz('Asia/Dubai').format('DD/MM/YYYY  H:mm:ss'), searchText) ||
          startsWith(_.get(item, 'vehicle.make', ''), searchText) ||
          startsWith(_.get(item, 'vehicle.model', ''), searchText)
      )
    );
  }, [searchText, userChargingHistoryList]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  useEffect(() => {
    userChargingHistory();
  }, []);

  // Download Excel Functionality

  const downloadUserChargingHistory = useCallback(() => {
    const data = {
      excel: true,
      from: moment(startDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
      to: moment(endDate).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'),
      report: 'usercharginghistory',
    };
    dispatch({
      type: DOWNLOAD_USER_CHARGING_HISTORY,
      payload: data,
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'User Charging history'}.xlsx`);
          }
        }
      },
    });
  }, [startDate, endDate]);

  const downloadFile = () => {
    downloadUserChargingHistory();
  };

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page,
      };
      userChargingHistory(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      userChargingHistory(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const search = <SearchBox preIcon={<BsSearch />} value={searchText} onChange={searchHandler} />;
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="User Charging History" />
        <div className="page-content-wrapper scrollable">
          <div className="data-report--main">
            <Card>
              <div className="data-report__inner">
                <div className="data-report__box">
                  <Row className="data-report__row">
                    <Col
                      xl={`${showSearchBar ? 4 : 1}`}
                      md={`${showSearchBar ? 12 : 2}`}
                      className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                    >
                      {showSearchBar ? search : searchIcon}
                    </Col>
                    {/* <Col xl={2} md={4}>
                      <DropDown
                        popupClass="main-menu bottom scrollable"
                        trigger={
                          <>
                            <div className="log-filter-block">
                              <div className="log-filter-icon">
                                <BsFilter />
                                <span className="log-filter-label">{fieldValue}</span>
                              </div>
                              <div className="log-arrow__icon">
                                <AiFillCaretDown />
                              </div>
                            </div>
                          </>
                        }
                        triggerClass="log-filter-dropdown"
                      >
                        {_.map(filterData, (item, index) => (
                          <ul key={`${index}`}>
                            <li
                              className="item"
                              onClick={() => {
                                setFieldValue(item.value);
                              }}
                            >
                              {item.label}
                            </li>
                          </ul>
                        ))}
                      </DropDown>
                    </Col> */}
                    <Col xl={`${showSearchBar ? 6 : 9}`} md={`${showSearchBar ? 10 : 10}`}>
                      <div className="data-report-date_picker">
                        <DateTimePicker
                          onChangeOfStartDate={(item) => setStartDate(item)}
                          onChangeOfEndDate={(item) => setEndDate(item)}
                          initialValueOfStartDate={moment(new Date()).tz('Asia/Dubai').startOf('day')}
                          initialValueOfEndDate={moment(new Date()).tz('Asia/Dubai').endOf('day')}
                        />
                      </div>
                    </Col>
                    <Col xl={1} md={2}>
                      <div className="report-search-box" onClick={dateFilter}>
                        <Button className="report-search-button">Search</Button>
                      </div>
                    </Col>
                    {/* <Col xl={2} md={4}>
                      <div className="report-search-excel-block">
                        <div className="advance-filter-btn">
                          <Button className="report-search-button">Advance Filter</Button>
                        </div>
                      </div>
                    </Col> */}
                    <Col xl={1} md={1} className="excel-icon--block">
                      <div className="report-excel-icon" onClick={downloadFile}>
                        {/* <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button"
                            table="table-to-xls"
                            filename="User Charging History"
                            sheet="User Charging History"
                            buttonText={<SiMicrosoftexcel size={28} />}
                          /> */}
                        <BsDownload size={28} color={'#3c7cdd'} />
                      </div>
                    </Col>
                    {/* <Col xl={1} md={2}>
                      <div className="data-report__table-download-icon">
                        <AiOutlineDownload />
                      </div>
                    </Col> */}
                  </Row>
                </div>
                <div className="data-report__table">
                  <div className="table-responsive">
                    <table className="record-list-table" id="table-to-xls">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Sr No.</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>User Name</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Mobile No</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Transaction Id</span>
                              <span className="ico" onClick={() => handleSorting('transaction_id', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Station Name</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Charger ID (Connector)</span>
                              {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Unit Consumed (kWh)</span>
                              <span className="ico" onClick={() => handleSorting('energy_consumed', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Energy Rate (Per Unit)</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Session Duration (HH:MM)</span>
                              <span className="ico" onClick={() => handleSorting('time_taken', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Net Amount (INR)</span>
                            </div>
                          </th>
                          {/* <th>
                            <div className="sorting">
                              <span>CGST Amount (INR)</span>
                            </div>
                          </th> */}
                          {/* <th>
                            <div className="sorting">
                              <span>SGST Amount (INR)</span>
                            </div>
                          </th> */}
                          {/* <th>
                            <div className="sorting">
                              <span>Offer Amount (INR)</span>
                            </div>
                          </th> */}
                          {/* <th>
                            <div className="sorting">
                              <span>Total Amount Paid (INR)</span>
                            </div>
                          </th> */}
                          <th>
                            <div className="sorting">
                              <span>Date & Time</span>
                              <span className="ico" onClick={() => handleSorting('schedule_datetime', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                              {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Make(Model)</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.isEmpty(allUserChargingHistoryData) ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="empty-data-block">No User Charging History Found</div>
                            </td>
                          </tr>
                        ) : (
                          _.map(allUserChargingHistoryData, (item, key) => {
                            const connectorData = _.find(_.get(item, 'charger.plugs', []), { connector_id: item.connectorId });
                            const unitConsumed = isNaN((_.get(item, 'meterstop') - _.get(item, 'meterstart')) / 1000)
                              ? ''
                              : roundOfDigit((_.get(item, 'meterstop') - _.get(item, 'meterstart')) / 1000, 3);
                            const pricePerUnit = unitConsumed
                              ? isNaN(parseFloat(_.get(item, 'invoice.subtotal') / unitConsumed).toFixed(2))
                                ? ''
                                : parseFloat(_.get(item, 'invoice.subtotal') / unitConsumed).toFixed(2)
                              : '';
                            return (
                              <tr key={`user-charging-history-${key}`}>
                                <td>{key + 1}</td>
                                <td>{_.get(item, 'customer_user_booked.name', 'Guest User')}</td>
                                <td>{_.get(item, 'customer_user_booked.phone')}</td>
                                <td>{_.get(item, 'transaction_id', '')}</td>
                                <td>{_.get(item, 'charger.charging_station.name', '')}</td>
                                <td>
                                  {_.get(item, 'charger.charger_id', '')} ({_.get(connectorData, 'name', '')})
                                </td>
                                <td>{unitConsumed}</td>
                                <td>{_.get(item, 'invoice.price_per_unit', pricePerUnit)}</td>
                                <td>{millisecondsToHourMinute(_.get(item, 'time_taken'))}</td>
                                <td>{isNaN(_.get(item, 'invoice.amount', '')) ? '' : roundOfDigit(_.get(item, 'invoice.amount', ''), 2)}</td>
                                <td>
                                  {_.get(item, 'schedule_datetime')
                                    ? moment(_.get(item, 'schedule_datetime')).tz('Asia/Dubai').format('DD/MM/YYYY  H:mm:ss')
                                    : ''}
                                </td>
                                <td>{_.get(item, 'vehicle.make', '') + (item.vehicle ? `(${_.get(item, 'vehicle.model', '')})` : '')}</td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </LayoutContainer>
    </>
  );
};

export default UserChargingHistory;
